class CustomStickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Only apply custom behavior on homepage
    if (!document.body.classList.contains('template-index')) {
      console.log('Not on homepage, skipping header customization');
      return;
    }

    console.log('Custom header element connected');

    // Find header elements within this custom element
    this.header = this.querySelector('.section-header');
    this.headerWrapper = this.querySelector('.header-wrapper');
    
    if (!this.header || !this.headerWrapper) {
      console.log('Header elements not found:', {
        hasHeader: !!this.header,
        hasWrapper: !!this.headerWrapper
      });
      return;
    }

    console.log('Found header elements:', {
      header: this.header.className,
      wrapper: this.headerWrapper.className
    });

    // Remove any existing sticky classes
    this.headerWrapper.classList.remove('header-wrapper--sticky');
    this.header.classList.remove('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');

    // Apply absolute positioning
    this.headerWrapper.style.position = 'absolute';
    this.headerWrapper.style.top = '0';
    this.headerWrapper.style.left = '0';
    this.headerWrapper.style.right = '0';
    this.headerWrapper.style.zIndex = '1000';
    this.headerWrapper.style.background = 'transparent';
    this.headerWrapper.style.borderBottom = 'none';
    this.headerWrapper.style.pointerEvents = 'auto';
    this.headerWrapper.style.margin = '0';
    this.headerWrapper.style.padding = '0';

    // Style the header
    this.header.style.position = 'absolute';
    this.header.style.top = '0';
    this.header.style.left = '0';
    this.header.style.right = '0';
    this.header.style.zIndex = '1000';
    this.header.style.marginBottom = '0';
    this.header.style.padding = '0';

    // Ensure main content starts at top
    const mainContent = document.querySelector('#MainContent');
    if (mainContent) {
      mainContent.style.position = 'relative';
      mainContent.style.zIndex = '1';
      mainContent.style.marginTop = '0';
      mainContent.style.paddingTop = '0';
    }

    // Make header menu items white
    const menuItems = this.headerWrapper.querySelectorAll('.header__menu-item, .header__menu-item span, .header__menu-item .icon-caret');
    menuItems.forEach(item => {
      item.style.color = '#ffffff';
      item.style.textShadow = '0 1px 2px rgba(0, 0, 0, 0.3)';
    });

    // Make header icons white
    const icons = this.headerWrapper.querySelectorAll('.header__icon, .header__icon .icon');
    icons.forEach(icon => {
      icon.style.color = '#ffffff';
      icon.style.filter = 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))';
    });

    // Add gradient overlay
    const gradientOverlay = document.createElement('div');
    gradientOverlay.style.position = 'absolute';
    gradientOverlay.style.top = '0';
    gradientOverlay.style.left = '0';
    gradientOverlay.style.right = '0';
    gradientOverlay.style.height = '100%';
    gradientOverlay.style.background = 'linear-gradient(to bottom, rgba(0, 0, 0, 0.2), transparent)';
    gradientOverlay.style.pointerEvents = 'none';
    gradientOverlay.style.zIndex = '-1';
    this.header.appendChild(gradientOverlay);

    // Log success
    console.log('Custom header styles applied successfully');
  }
}

customElements.define('custom-sticky-header', CustomStickyHeader); 